export function getProduct(data) {
    let { getProductRequest, getProductError, getProductResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/product/get_product',
        this.createBundle('app/product/get_product', { code: data }, this.GET, getProductRequest, getProductResult, getProductError)
    )
}
